import React from 'react';
import { Link } from 'react-router-dom';

const PreviousYearPapers: React.FC = () => {
  return (
    <div className="min-vh-100 mt-4" style={{ backgroundColor: '#f8f9ff', paddingTop: '0px' }}>
      <div className="container py-0">
        <div className="row justify-content-center">
          <div className="col-12 col-lg-10">
            {/* Header Section */}
            <div className="card border-0 shadow-sm mb-4" style={{ borderRadius: '20px' }}>
              <div className="card-body p-4" style={{
                background: 'linear-gradient(135deg, #6f42c1, #e83e8c)',
                borderRadius: '20px'
              }}>
                <div className="row align-items-center">
                  <div className="col-md-8">
                    <h1 className="text-white fw-bold mb-2">
                      <i className="fas fa-archive me-3"></i>
                      Previous Year Papers 📚
                    </h1>
                    <p className="text-white opacity-90 mb-0 fs-5">
                      Practice with authentic question papers from previous years to boost your exam preparation.
                    </p>
                  </div>
                  <div className="col-md-4 text-end">
                    <div className="d-inline-flex align-items-center justify-content-center rounded-circle"
                      style={{ 
                        width: '80px', 
                        height: '80px',
                        backgroundColor: 'rgba(255,255,255,0.2)'
                      }}>
                      <i className="fas fa-graduation-cap text-white fa-2x"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Coming Soon Section */}
            <div className="card border-0 shadow-sm" style={{ borderRadius: '20px' }}>
              <div className="card-body text-center py-5 px-4">
                {/* Animated Icon */}
                <div className="mb-4">
                  <div className="d-inline-flex align-items-center justify-content-center rounded-circle mb-3"
                    style={{ 
                      width: '120px', 
                      height: '120px',
                      background: 'linear-gradient(135deg, #6f42c1, #e83e8c)',
                      animation: 'pulse 2s infinite'
                    }}>
                    <i className="fas fa-tools text-white fa-3x"></i>
                  </div>
                </div>

                {/* Coming Soon Message */}
                <h2 className="fw-bold mb-3" style={{ color: '#6f42c1' }}>
                  Coming Soon! 🚀
                </h2>
                <p className="text-muted fs-5 mb-4 mx-auto" style={{ maxWidth: '600px' }}>
                  We're working hard to bring you an extensive collection of previous year question papers. 
                  This feature will include papers from multiple years, subjects, and examination boards.
                </p>

                {/* Feature Preview */}
                <div className="row g-4 mb-5">
                  <div className="col-md-4">
                    <div className="p-4 rounded-4" style={{ backgroundColor: '#f8f9ff' }}>
                      <div className="d-inline-flex align-items-center justify-content-center rounded-circle mb-3"
                        style={{ 
                          width: '60px', 
                          height: '60px',
                          backgroundColor: '#6f42c115',
                          border: '2px solid #6f42c1'
                        }}>
                        <i className="fas fa-calendar-alt text-primary fa-lg"></i>
                      </div>
                      <h5 className="fw-bold mb-2">Multiple Years</h5>
                      <p className="text-muted small mb-0">
                        Access papers from the last 5-10 years for comprehensive practice
                      </p>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="p-4 rounded-4" style={{ backgroundColor: '#f8f9ff' }}>
                      <div className="d-inline-flex align-items-center justify-content-center rounded-circle mb-3"
                        style={{ 
                          width: '60px', 
                          height: '60px',
                          backgroundColor: '#e83e8c15',
                          border: '2px solid #e83e8c'
                        }}>
                        <i className="fas fa-book text-danger fa-lg"></i>
                      </div>
                      <h5 className="fw-bold mb-2">All Subjects</h5>
                      <p className="text-muted small mb-0">
                        Complete collection covering all subjects and topics
                      </p>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="p-4 rounded-4" style={{ backgroundColor: '#f8f9ff' }}>
                      <div className="d-inline-flex align-items-center justify-content-center rounded-circle mb-3"
                        style={{ 
                          width: '60px', 
                          height: '60px',
                          backgroundColor: '#28a74515',
                          border: '2px solid #28a745'
                        }}>
                        <i className="fas fa-chart-line text-success fa-lg"></i>
                      </div>
                      <h5 className="fw-bold mb-2">Performance Analytics</h5>
                      <p className="text-muted small mb-0">
                        Detailed analysis and comparison with previous year trends
                      </p>
                    </div>
                  </div>
                </div>

                {/* Notification Signup */}
                <div className="card border-0" style={{ backgroundColor: '#f8f9ff', borderRadius: '15px' }}>
                  <div className="card-body p-4">
                    <h5 className="fw-bold mb-3">
                      <i className="fas fa-bell me-2 text-warning"></i>
                      Get Notified When It's Ready!
                    </h5>
                    <p className="text-muted mb-4">
                      We'll notify you as soon as the Previous Year Papers feature is available.
                    </p>
                    <div className="row g-3 justify-content-center">
                      <div className="col-auto">
                        <button className="btn btn-outline-primary btn-lg px-4" style={{ borderRadius: '12px' }}>
                          <i className="fas fa-envelope me-2"></i>
                          Notify Me
                        </button>
                      </div>
                      <div className="col-auto">
                        <Link 
                          to="/dashboard" 
                          className="btn btn-primary btn-lg px-4"
                          style={{ borderRadius: '12px' }}>
                          <i className="fas fa-arrow-left me-2"></i>
                          Back to Dashboard
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Progress Indicator */}
                <div className="mt-5">
                  <h6 className="text-muted mb-3">Development Progress</h6>
                  <div className="progress mx-auto" style={{ height: '10px', maxWidth: '400px' }}>
                    <div 
                      className="progress-bar progress-bar-striped progress-bar-animated"
                      style={{ 
                        width: '65%',
                        background: 'linear-gradient(45deg, #6f42c1, #e83e8c)'
                      }}
                    ></div>
                  </div>
                  <small className="text-muted mt-2 d-block">65% Complete</small>
                </div>
              </div>
            </div>

            {/* Additional Information */}
            <div className="row g-4 mt-4">
              <div className="col-md-6">
                <div className="card border-0 shadow-sm h-100" style={{ borderRadius: '15px' }}>
                  <div className="card-body p-4">
                    <h5 className="fw-bold mb-3">
                      <i className="fas fa-question-circle me-2 text-info"></i>
                      What to Expect?
                    </h5>
                    <ul className="list-unstyled mb-0">
                      <li className="mb-2">
                        <i className="fas fa-check text-success me-2"></i>
                        Original question paper formats
                      </li>
                      <li className="mb-2">
                        <i className="fas fa-check text-success me-2"></i>
                        Time-bound practice sessions
                      </li>
                      <li className="mb-2">
                        <i className="fas fa-check text-success me-2"></i>
                        Detailed solution explanations
                      </li>
                      <li className="mb-2">
                        <i className="fas fa-check text-success me-2"></i>
                        Year-wise difficulty analysis
                      </li>
                      <li className="mb-0">
                        <i className="fas fa-check text-success me-2"></i>
                        Trend analysis and predictions
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="card border-0 shadow-sm h-100" style={{ borderRadius: '15px' }}>
                  <div className="card-body p-4">
                    <h5 className="fw-bold mb-3">
                      <i className="fas fa-clock me-2 text-warning"></i>
                      Timeline
                    </h5>
                    <div className="timeline">
                      <div className="d-flex align-items-center mb-3">
                        <div className="rounded-circle bg-success me-3" style={{ width: '12px', height: '12px' }}></div>
                        <span className="text-muted">Research & Collection - <strong className="text-success">Completed</strong></span>
                      </div>
                      <div className="d-flex align-items-center mb-3">
                        <div className="rounded-circle bg-warning me-3" style={{ width: '12px', height: '12px' }}></div>
                        <span className="text-muted">Development - <strong className="text-warning">In Progress</strong></span>
                      </div>
                      <div className="d-flex align-items-center mb-3">
                        <div className="rounded-circle bg-secondary me-3" style={{ width: '12px', height: '12px' }}></div>
                        <span className="text-muted">Testing - <strong className="text-secondary">Upcoming</strong></span>
                      </div>
                      <div className="d-flex align-items-center mb-0">
                        <div className="rounded-circle bg-primary me-3" style={{ width: '12px', height: '12px' }}></div>
                        <span className="text-muted">Launch - <strong className="text-primary">December 2025</strong></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes pulse {
          0% {
            transform: scale(1);
            box-shadow: 0 0 0 0 rgba(111, 66, 193, 0.7);
          }
          70% {
            transform: scale(1.05);
            box-shadow: 0 0 0 10px rgba(111, 66, 193, 0);
          }
          100% {
            transform: scale(1);
            box-shadow: 0 0 0 0 rgba(111, 66, 193, 0);
          }
        }
      `}</style>
    </div>
  );
};

export default PreviousYearPapers;